import ExtraUserInputsPage from "./ExtraUserInputsPage";

export default ExtraUserInputsPage;
